import React from 'react';
import { Zap } from 'lucide-react';

/**
 * The thing at the top of the feed that starts a post.
 *
 * It looks like a composer and is a button, which is the point. Players do not write
 * on the Banterboard — they choose from a vetted vocabulary, and that is what means
 * there is nothing to moderate after the fact. What was wrong before was not the
 * absence of a text box, it was that the whole phrase library had to be on screen
 * permanently for the absence to make sense. One bar, and the library is a tap away.
 *
 * A single tap target rather than a row of small ones: on a phone the entire bar is
 * the button, so there is nothing to miss.
 */
function BanterComposer({ onOpen, disabled }) {
  return (
    <button
      type="button"
      className="banter-composer"
      onClick={onOpen}
      disabled={disabled}
      aria-label="Say something — choose a line to post"
    >
      <span className="banter-composer-prompt">Say something…</span>
      <span className="banter-composer-cue">
        <Zap size={14} aria-hidden="true" />
        Quick Banter
      </span>
    </button>
  );
}

export default BanterComposer;
